/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getServices.defs.js'
export * as $defs from './getServices.defs.js'
